import { createAction, props } from "@ngrx/store";

/// Actions SHELL
export const setProgreesBar = createAction('[setMenu] setProgreesBar', props<{ progressBar : boolean }>());
export const setLoadInitial = createAction('[setMenu] setLoadInitial', props<{ loadInitial : boolean }>());